import {getDataInLocalStorage, saveDataToLocalStorage} from '@/utils/localStorageUtils'
import {userTransDown} from "@/utils/user";

const state = {
  user: '',
  token: '',
  role: '',
  project: new Set(['projectList:createAnal', 'projectList:group']),
  saler: new Set(['projectList:createAnal', 'projectList:group', ]),
  analyzer: new Set(['projectList:createProject',  'projectList:download',
    'projectList:preview', 'projectList:reUpload',  'user:testEmail', 'project:delete']),
  manager: new Set(['projectList:createProject' , 'projectList:exportProject', 'projectList:createAnal', 'projectList:group',
    'userList:addUser', 'userList:delUser', 'userList:updateUser', 'userList:updatePwd', 'user:editInfo', 'user:editPwd', 'user:testEmail', 'project:changeUser', 'project:delete', 'project:auditRawData']),
  customer: new Set(['projectList:createAnal', 'projectList:group', 'user:editInfo', 'user:editPwd']),
  auditor: new Set(['projectList:createAnal', 'projectList:group', 'project:noComeAnalyze', 'user:editInfo', 'user:editPwd', 'project:auditRawData'])
}
const getters = {
  getUser: (state) => {
    if (!state.user) {
      var userJson = getDataInLocalStorage('user')
      if (userJson) {
        state.user = JSON.parse(getDataInLocalStorage('user'))
      }
    }
    return state.user
  },
  hasRight: (state) => (resource) => {
    return state.role && state[state.role] && state[state.role].has(resource)
  },
  getRole: (state) => {
    if (!state.role) {
      state.role = getDataInLocalStorage('role')
    }
    return state.role
  },
  getToken: (state) => {
    if (!state.token) {
      state.token = getDataInLocalStorage('token')
    }
    return state.token
  }
}
const mutations = {
  setUser: (state, user) => {
    saveDataToLocalStorage("user", JSON.stringify(user))
    state.user = user
  },
  setRole: (state, role) => {
    role=userTransDown(role)
    saveDataToLocalStorage('role', role)
    state.role = role
  },
  setToken: (state, token) => {
    saveDataToLocalStorage('token', token)
    state.token = token
  },
  initRightInfo: (state) => {
    state.user = ''
    state.role = ''
    state.token = ''
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
